import { useCallback } from 'react';
import { useField } from 'formik';
import type { TextFieldProps } from '@gusto/workbench-formik';
import { TextField } from '@gusto/workbench-formik';
import { formatPhoneNumber } from '@gusto/workbench';
import type { ChangeEvent, FocusEvent } from 'react';

export interface FormattedPhoneFieldProps extends TextFieldProps {}

const FormattedPhoneField = (props: FormattedPhoneFieldProps) => {
  const [field, , helpers] = useField(props);

  const handleChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      helpers.setValue(e.target.value);
    },
    [helpers]
  );

  const handleBlur = useCallback(
    (e: FocusEvent<HTMLInputElement>) => {
      helpers.setValue(formatPhoneNumber(e.target.value));
    },
    [helpers]
  );

  return <TextField {...field} {...props} onChange={handleChange} onBlur={handleBlur} />;
};

export default FormattedPhoneField;
